import { createFeatureSelector, createSelector } from "@ngrx/store";
import { BillOfMaterialsLineItem, BillOfMaterialsLineItemType, ComplaintLog, ComplaintLogProduct, Contact, DisplayedInventoryTransactionActivity, EditPlasticsOrderState, EditPlasticsProductState, MappingComplaintLogToContact, MappingComplaintLogToQualityAlert, MappingProductVersionToDockInspectionQuailtyAlert, MappingProductVersionToQualityAlert, PlasticsMaterialMixingTask, PlasticsCalendarEvent, PlasticsFinishingStation, PlasticsFinishingTask, PlasticsFixture, InventoryTransaction, InventoryTransactionType, PlasticsHardwareItem, LabelInstance, PlasticsMaterial, PlasticsMoldingTask, PlasticsOrder, PlasticsOrderedProduct, PlasticsQualityAlert, PlasticsQualityAlertInspection, PlasticsScrapInstance, PlasticsScrapReason, PlasticsSkid, Product, ProductInstance, ProductList, ProductType, ProductVersion, ProductVersionStatus, Resource, RotoMachine, RotoManagementState, RotoSchedule, SaveStatus, SkidMultiScanState, Tag, TagCategory, toEntityDict, VendorHardwareData, ViewPlasticsProductState, MappingProductVersionToPlasticsStaticLabel, PlasticsStaticLabel, MappingPlasticsMaterialToQualityAlert, ProductVersionMoldConfig } from "@prism/prism-shared";
import { PlasticsState } from "./plastics.reducer";

export const plasticsState = createFeatureSelector<PlasticsState>('plastics');

export const getLoadingState = createSelector(
    plasticsState,
    (state: PlasticsState): number => state.loadingState
);

export const getError = createSelector(
    plasticsState,
    (state: PlasticsState): any => state.error
);

export const getHardwareItems = createSelector(
    plasticsState,
    (state: PlasticsState): PlasticsHardwareItem[] => state.hardwareItems
);

export const getVendorHardwareData = createSelector(
    plasticsState,
    (state: PlasticsState): VendorHardwareData[] => state.vendorHardwareData
);

export const getContacts = createSelector(
    plasticsState,
    (state: PlasticsState): Contact[] => state.contacts
);

export const getTags = createSelector(
    plasticsState,
    (state: PlasticsState): Tag[] => state.tags
);

export const getProducts = createSelector(
    plasticsState,
    (state: PlasticsState): Product[] => state.products
);

export const getProductVersions = createSelector(
    plasticsState,
    (state: PlasticsState): ProductVersion[] => state.productVersions
);

export const getHardwareInventoryTransactions = createSelector(
    plasticsState,
    (state: PlasticsState): InventoryTransaction[] => state.inventoryTransactions.filter(t => t.type === InventoryTransactionType.PlasticsHardware)
);

export const getProductInventoryTransactions = createSelector(
    plasticsState,
    (state: PlasticsState): InventoryTransaction[] => state.inventoryTransactions.filter(t => t.type === InventoryTransactionType.PlasticsProduct)
);

export const getRotoManagementState = createSelector(
    plasticsState,
    (state: PlasticsState): RotoManagementState => state.rotoManagementState
);

export const getBillOfMaterialsLineItems = createSelector(
    plasticsState,
    (state: PlasticsState): BillOfMaterialsLineItem[] => state.billOfMaterialsLineItems
);

export const getFixtures = createSelector(
    plasticsState,
    (state: PlasticsState): PlasticsFixture[] => state.fixtures
)

export const getEditPlasticsOrderState = createSelector(
    plasticsState,
    (state: PlasticsState): EditPlasticsOrderState => state.editPlasticsOrderState
)

export const getRotoMachines = createSelector(
    plasticsState,
    (state: PlasticsState): RotoMachine[] => state.rotoMachines
)

export const getMaterials = createSelector(
    plasticsState,
    (state: PlasticsState): PlasticsMaterial[] => state.materials
)

export const getMaterialInventoryTransactions = createSelector(
    plasticsState,
    (state: PlasticsState): InventoryTransaction[] => state.inventoryTransactions.filter(t => t.type === InventoryTransactionType.PlasticsMaterial)
)

export const getScrapReasons = createSelector(
    plasticsState,
    (state: PlasticsState): PlasticsScrapReason[] => state.scrapReasons
)

export const getPlasticsScrapInstances = createSelector(
    plasticsState,
    (state: PlasticsState): PlasticsScrapInstance[] => state.plasticsScrapInstances
)

export const getPlasticsQualityAlerts = createSelector(
    plasticsState,
    (state: PlasticsState): PlasticsQualityAlert[] => state.plasticsQualityAlerts
)

export const getPlasticsStaticLabels = createSelector(
    plasticsState,
    (state: PlasticsState): PlasticsStaticLabel[] => state.plasticsStaticLabel
)

export const getProductDockInspectionQualityAlerts = createSelector(
    plasticsState,
    (state: PlasticsState): PlasticsQualityAlert[] => state.productDockInspectionQualityAlerts
)

export const getPlasticsFinishingStations = createSelector(
    plasticsState,
    (state: PlasticsState): PlasticsFinishingStation[] => state.plasticsFinishingStations
)

export const getOrders = createSelector(
    plasticsState,
    (state: PlasticsState): PlasticsOrder[] => state.plasticsOrders
)

export const getOrderedProducts = createSelector(
    plasticsState,
    (state: PlasticsState): PlasticsOrderedProduct[] => state.orderedProducts
)
export const getMappingProductVersionToQualityAlerts = createSelector(
    plasticsState,
    (state: PlasticsState): MappingProductVersionToQualityAlert[] => state.mappingProductVersionToQualityAlerts
)

export const getMappingPlasticsMaterialToQualityAlerts = createSelector(
    plasticsState,
    (state: PlasticsState): MappingPlasticsMaterialToQualityAlert[] => state.mappingPlasticsMaterialToQualityAlerts
)

export const getMappingProductVersionToDockInspections = createSelector(
    plasticsState,
    (state: PlasticsState): MappingProductVersionToQualityAlert[] => state.mappingProductVersionToDockInspectionQualityAlerts
)

export const getCalendarEvents = createSelector(
    plasticsState,
    (state: PlasticsState): PlasticsCalendarEvent[] => state.calendarEvents
)


export const getRotoSchedule = createSelector(
    plasticsState,
    (state: PlasticsState): RotoSchedule => state.rotoSchedule
)

export const getComplaintLogs = createSelector(
    plasticsState,
    (state: PlasticsState): ComplaintLog[] => state.complaintLogs
)

export const getComplaintLogProducts = createSelector(
    plasticsState,
    (state: PlasticsState): ComplaintLogProduct[] => state.complaintLogProducts
)

export const getMoldingTasks = createSelector(
    plasticsState,
    (state: PlasticsState): PlasticsMoldingTask[] => state.moldingTasks
)

export const getFinishingTasks = createSelector(
    plasticsState,
    (state: PlasticsState): PlasticsFinishingTask[] => state.finishingTasks
)

export const getMixingTasks = createSelector(
    plasticsState,
    (state: PlasticsState): PlasticsMaterialMixingTask[] => state.mixingTasks
)


export const getMappingComplaintLogToQualityAlert = createSelector(
    plasticsState,
    (state: PlasticsState): MappingComplaintLogToQualityAlert[] => state.mappingComplaintLogToQualityAlert
)

export const getMappingComplaintLogToContact = createSelector(
    plasticsState,
    (state: PlasticsState): MappingComplaintLogToContact[] => state.mappingComplaintLogToContact
)

export const getPlasticsQualityAlertsInspections = createSelector(
    plasticsState,
    (state: PlasticsState): PlasticsQualityAlertInspection[] => state.qualityAlertInspections
)

export const getLabelInstances = createSelector(
    plasticsState,
    (state: PlasticsState): LabelInstance[] => state.labelInstances
)

export const getSkids = createSelector(
    plasticsState,
    (state: PlasticsState): PlasticsSkid[] => state.skids
)

export const getProductInstances = createSelector(
    plasticsState,
    (state: PlasticsState): ProductInstance[] => state.productInstances
)

export const getSkidMultiScanState = createSelector(
    plasticsState,
    (state: PlasticsState): SkidMultiScanState => state.skidMultiScanState
)

// above are selectors that ONLY use plasticsState
// =========================================================
// below are selectors that are built with selectors above



export const getSortedRotoMachines = createSelector(
    getRotoMachines,
    (rotoMachines: RotoMachine[]): RotoMachine[] => [...rotoMachines].sort((a, b) => a.name.localeCompare(b.name))
)


export const getRotoManagementBillOfMaterialsLineItems = createSelector(
    getRotoManagementState,
    (state: RotoManagementState): BillOfMaterialsLineItem[] => state.billOfMaterialsLineItems
);

export const getReleasedProductVersions = createSelector(
    getProductVersions,
    (productVersions: ProductVersion[]): ProductVersion[] => {
        return productVersions.filter(productVersion => productVersion.status === ProductVersionStatus.Released)
    }
);

export const getFinishedProductVersions = createSelector(
    getProductVersions,
    (productVersions: ProductVersion[]): ProductVersion[] => {
        return productVersions.filter(productVersion => productVersion.type === ProductType.FINISHED)
    }
)

export const getDraftProductVersions = createSelector(
    getProductVersions,
    (productVersions: ProductVersion[]): ProductVersion[] => {
        return productVersions.filter(productVersion => productVersion.status === ProductVersionStatus.Draft)
    }
)

export const getProductIdToReleasedProductVersionDict = createSelector(
    getReleasedProductVersions,
    (versions: ProductVersion[]): Record<string, ProductVersion> => toEntityDict<ProductVersion>(versions, 'productId')

)
export const getProductIdToProductVersionDict = createSelector(
    getProductVersions,
    (versions: ProductVersion[]): Record<string, ProductVersion> => toEntityDict<ProductVersion>(versions, 'productId')
)

export function getReleasedProductVersionsByCustomerId(customerId: string) {

    return createSelector(
        getReleasedProductVersions,
        (productVersions: ProductVersion[]): ProductVersion[] => {
            return productVersions.filter(productVersion => productVersion.customerId === customerId)
        }
    )
}

export const getReleasedAndDraftProductVersions = createSelector(
    getProductVersions,
    (productVersions: ProductVersion[]): ProductVersion[] => {
        return productVersions.filter(productVersion =>
            productVersion.status === ProductVersionStatus.Released ||
            productVersion.status === ProductVersionStatus.Draft
        )
    }
);

export function getProductVersionsByFixtureId(fixtureId: string) {
    return createSelector(
        getProductVersions,
        (versions: ProductVersion[]): ProductVersion[] => {
            return versions.filter(version => version.fixtureId === fixtureId)
        }
    )
}

export const getFixtureDict = createSelector(
    getFixtures,
    (fixtures: PlasticsFixture[]): Record<string, PlasticsFixture> => toEntityDict<PlasticsFixture>(fixtures)
)



export const getRotoManagementRotoSchedule = createSelector(
    getRotoManagementState,
    (state: RotoManagementState): RotoSchedule => state.rotoSchedule
);

export const getRotoScheduleMoldingTasks = createSelector(
    getRotoManagementState,
    (state: RotoManagementState): PlasticsMoldingTask[] => state.moldingTasks
);

export const getRotoScheduleProductLists = createSelector(
    getRotoManagementRotoSchedule,
    (rotoSchedule: RotoSchedule): ProductList[] => rotoSchedule?.productLists || []
);

export const getEditPlasticsOrder = createSelector(
    getEditPlasticsOrderState,
    (state: EditPlasticsOrderState): PlasticsOrder => state.order
);

export const getEditPlasticsOrderedProducts = createSelector(
    getEditPlasticsOrderState,
    (state: EditPlasticsOrderState): PlasticsOrderedProduct[] => state.orderedProducts
);

export const getEditPlasticsOrderSaveStatus = createSelector(
    getEditPlasticsOrderState,
    (state: EditPlasticsOrderState): SaveStatus => state.saveStatus
);

export function getOrderedProductsByCustomerId(customerId: string) {
    return createSelector(
        getOrderedProducts,
        (orderedProducts: PlasticsOrderedProduct[]): PlasticsOrderedProduct[] => {
            return orderedProducts.filter(orderedProduct => orderedProduct.customerId === customerId);
        }
    )
}


export function getHardwareItemById(hardwareItemId: string) {
    return createSelector(
        getHardwareItems,
        (hardwareItems: PlasticsHardwareItem[]): PlasticsHardwareItem => {
            return hardwareItems.find(hardwareItem => hardwareItem.id === hardwareItemId) as PlasticsHardwareItem;
        }
    )
}

export function getReleasedProductVersionByProductId(productId: string) {
    return createSelector(
        getReleasedProductVersions,
        (productVersions: ProductVersion[]): ProductVersion => {
            return productVersions.find(productVersion => productVersion.productId === productId) as ProductVersion;
        }
    )
}

export function getRotoMachineById(rotoMachineId: string) {
    return createSelector(
        getRotoMachines,
        (rotoMachines: RotoMachine[]): RotoMachine => {
            return rotoMachines.find(rotoMachine => rotoMachine.id === rotoMachineId) as RotoMachine;
        }
    )
}

export function getVendorHardwareDataByHardwareItemId(hardwareItemId: string) {
    return createSelector(
        getVendorHardwareData,
        (vendorHardwareData: VendorHardwareData[]): VendorHardwareData[] => {
            return vendorHardwareData.filter(vendorHardwareData => vendorHardwareData.parentHardwareItemId === hardwareItemId);
        }
    )
}

export function getProductById(productId: string) {
    return createSelector(
        getProducts,
        (products: Product[]): Product => {
            return products.find(product => product.id === productId) as Product;
        }
    )
}

export function getMaterialById(materialId: string) {
    return createSelector(
        getMaterials,
        (materials: PlasticsMaterial[]): PlasticsMaterial => {
            return materials.find(material => material.id === materialId) as PlasticsMaterial;
        }
    )
}


export function getTagsByCategory(category: TagCategory) {
    return createSelector(
        getTags,
        (tags: Tag[]): Tag[] => {
            return tags.filter(tag => tag.category === category);
        }
    )
}

export function getBillOfMaterialsLineItemsByProductVersionId(productVersionId: string) {
    return createSelector(
        getBillOfMaterialsLineItems,
        (billOfMaterialsLineItems: BillOfMaterialsLineItem[]): BillOfMaterialsLineItem[] => {
            return billOfMaterialsLineItems.filter(billOfMaterialsLineItems => billOfMaterialsLineItems.productVersionId === productVersionId)
        }
    )
}


export function getFixtureById(fixtureId: string) {
    return createSelector(
        getFixtures,
        (fixtures: PlasticsFixture[]): PlasticsFixture => {
            return fixtures.find(fixture => fixture.id === fixtureId) as PlasticsFixture
        }
    )
}

export const getContactDict = createSelector(
    getContacts,
    (contacts: Contact[]): Record<string, Contact> => toEntityDict<Contact>(contacts)
);

export const getVendorHardwareDataDict = createSelector(
    getVendorHardwareData,
    (vendorHardwareData: VendorHardwareData[]): Record<string, VendorHardwareData> => toEntityDict<VendorHardwareData>(vendorHardwareData)
);

export const getHardwareItemDict = createSelector(
    getHardwareItems,
    (hardwareItems: PlasticsHardwareItem[]): Record<string, PlasticsHardwareItem> => toEntityDict<PlasticsHardwareItem>(hardwareItems)
);

export const getTagsDict = createSelector(
    getTags,
    (tags: Tag[]): Record<string, Tag> => toEntityDict<Tag>(tags || [])
);

export const getProductDict = createSelector(
    getProducts,
    (products: Product[]): Record<string, Product> => toEntityDict<Product>(products)
);

export const getMaterialDict = createSelector(
    getMaterials,
    (materials: PlasticsMaterial[]): Record<string, PlasticsMaterial> => toEntityDict<PlasticsMaterial>(materials)
);

export const getProductVersionDict = createSelector(
    getProductVersions,
    (productVersions: ProductVersion[]): Record<string, ProductVersion> => toEntityDict<ProductVersion>(productVersions)
)

export const getProductVersionProductIdDict = createSelector(
    getProductVersions,
    (productVersions: ProductVersion[]): Record<string, ProductVersion> => toEntityDict(productVersions, 'productId')
)

export const getScheduledProductDict = createSelector(
    getRotoScheduleMoldingTasks,
    (scheduledProducts: PlasticsMoldingTask[]): Record<string, PlasticsMoldingTask> => toEntityDict<PlasticsMoldingTask>(scheduledProducts)
);

export const getPlasticsFinishingTasksDict = createSelector(
    getFinishingTasks,
    (finishingTasks: PlasticsFinishingTask[]): Record<string, PlasticsFinishingTask> => toEntityDict<PlasticsFinishingTask>(finishingTasks)
)

export const getRecentHardwareInventoryActivity = createSelector(
    getHardwareInventoryTransactions,
    (inventoryTransactions: InventoryTransaction[]): Record<string, DisplayedInventoryTransactionActivity> => {
        const _24HoursAgo = new Date(Date.now() - 24 * 60 * 60 * 1000)

        const filteredTransactions = inventoryTransactions.filter(transaction => transaction.createdOn.getTime() > _24HoursAgo.getTime())
        const uniqueHardwareIds = [...new Set(filteredTransactions.map(transaction => transaction.entityId))]

        const activity: Record<string, DisplayedInventoryTransactionActivity> = {}

        uniqueHardwareIds.forEach(hardwareItemId => {

            const transactionsForHardwareItem = filteredTransactions.filter(transaction => transaction.entityId === hardwareItemId)

            const net = transactionsForHardwareItem.reduce((acc, transaction) => (acc + transaction.change), 0)
            const increase = transactionsForHardwareItem.filter(transaction => transaction.change > 0).reduce((acc, transaction) => (acc + transaction.change), 0)
            const decrease = transactionsForHardwareItem.filter(transaction => transaction.change < 0).reduce((acc, transaction) => (acc + transaction.change), 0)

            activity[hardwareItemId] = {
                net,
                increase,
                decrease
            }
        })

        return activity
    }

)


export const getRecentProductInventoryActivity = createSelector(
    getProductInventoryTransactions,
    (inventoryTransactions: InventoryTransaction[]): Record<string, DisplayedInventoryTransactionActivity> => {
        const _24HoursAgo = new Date(Date.now() - 24 * 60 * 60 * 1000)

        const filteredTransactions = inventoryTransactions.filter(transaction => transaction.createdOn.getTime() > _24HoursAgo.getTime())
        const uniqueProductIds = [...new Set(filteredTransactions.map(transaction => transaction.entityId))]

        const activity: Record<string, DisplayedInventoryTransactionActivity> = {}

        uniqueProductIds.forEach(productId => {

            const transactionsForProduct = filteredTransactions.filter(transaction => transaction.entityId === productId)

            const net = transactionsForProduct.reduce((acc, transaction) => (acc + transaction.change), 0)
            const increase = transactionsForProduct.filter(transaction => transaction.change > 0).reduce((acc, transaction) => (acc + transaction.change), 0)
            const decrease = transactionsForProduct.filter(transaction => transaction.change < 0).reduce((acc, transaction) => (acc + transaction.change), 0)

            activity[productId] = {
                net,
                increase,
                decrease
            }
        })

        return activity
    }

)

export const getRecentMaterialInventoryActivity = createSelector(
    getMaterialInventoryTransactions,
    (inventoryTransactions: InventoryTransaction[]): Record<string, DisplayedInventoryTransactionActivity> => {
        const _24HoursAgo = new Date(Date.now() - 24 * 60 * 60 * 1000)

        const filteredTransactions = inventoryTransactions.filter(transaction => transaction.createdOn.getTime() > _24HoursAgo.getTime())
        const uniqueProductIds = [...new Set(filteredTransactions.map(transaction => transaction.entityId))]

        const activity: Record<string, DisplayedInventoryTransactionActivity> = {}

        uniqueProductIds.forEach(materialId => {

            const transactionsForProduct = filteredTransactions.filter(transaction => transaction.entityId === materialId)

            const net = transactionsForProduct.reduce((acc, transaction) => (acc + transaction.change), 0)
            const increase = transactionsForProduct.filter(transaction => transaction.change > 0).reduce((acc, transaction) => (acc + transaction.change), 0)
            const decrease = transactionsForProduct.filter(transaction => transaction.change < 0).reduce((acc, transaction) => (acc + transaction.change), 0)

            activity[materialId] = {
                net,
                increase,
                decrease
            }
        })

        return activity
    }

)

export function getMaterialsByIngredientHardwareItemId(hardwareItemId: string) {
    return createSelector(
        getMaterials,
        (materials: PlasticsMaterial[]): PlasticsMaterial[] => {
            return materials.filter((material) => material.ingredients.some(ingredient => ingredient.hardwareItemId === hardwareItemId))
        }
    )
}
